import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function WhatYouGet() {
  const deliverables = [{
    title: 'Guía PDF completa',
    desc: 'Optimizada para leer rápido y pasar a la acción.'
  }, {
    title: 'Plantilla de validación exprés',
    desc: 'Prueba tu idea en 24 horas sin gastar dinero.'
  }, {
    title: 'Checklist de lanzamiento en 7 días',
    desc: 'Tareas diarias claras para no perder el enfoque.'
  }, {
    title: 'Matriz de precios iniciales',
    desc: 'Ajusta el valor de tu servicio o producto sin dudar.'
  }, {
    title: 'Hoja de ruta para escalar',
    desc: 'Cómo automatizar tus siguientes pasos.'
  }, {
    title: 'Ejemplos de micro-emprendimientos rentables',
    desc: 'Casos reales que funcionan hoy.'
  }, {
    title: 'Mini-guía de errores comunes',
    desc: 'Lo que debes evitar para no perder tiempo ni dinero.'
  }];
  return <section className="py-24 px-6 lg:px-8 bg-brand-light text-slate-900" data-id="element-203">
      <div className="max-w-4xl mx-auto" data-id="element-204">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-205">
          <h2 className="font-heading text-3xl md:text-4xl font-bold mb-4 text-brand-dark" data-id="element-206">
            Esto es lo que recibes hoy
          </h2>
        </motion.div>

        <div className="bg-white rounded-3xl p-8 md:p-12 shadow-sm border border-slate-200" data-id="element-207">
          <div className="space-y-6" data-id="element-208">
            {deliverables.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.05
          }} className="flex items-start gap-4 pb-6 border-b border-slate-100 last:border-0 last:pb-0" data-id="element-209">
                <CheckCircle2 className="w-7 h-7 text-brand-accent shrink-0 mt-0.5" data-id="element-210" />
                <div data-id="element-211">
                  <h4 className="text-lg font-bold text-slate-800 mb-1" data-id="element-212">
                    {item.title}
                  </h4>
                  <p className="text-slate-600" data-id="element-213">{item.desc}</p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}